<ng-content>

</ng-content>


<!-- Main Container -->
<div class="w-full flex flex-col lg:flex-row gap-4">
  <!-- Form Section -->
  <div class="w-full lg:w-1/2 shadow-md rounded-xl p-4 bg-[var(--text-light)]">
    <form [formGroup]="newsForm" (ngSubmit)="submit()" class="space-y-4">
      <!-- Title Input -->
      <div class="space-y-2">
        <label for="title" class="block text-sm font-semibold">العنوان</label>
        <input pInputText type="text" id="title" name="title" placeholder="ادخل العنوان"
          class="w-full shadow-sm rounded-lg" formControlName="title" />
        <small class="text-red-500 block" *ngIf="!newsForm.get('title')?.valid && newsForm.get('title')?.touched">
          الاسم مطلوب
        </small>
      </div>

      <!-- Cover Image Upload -->
      <div class="space-y-2">
        <label for="cover_image" class="block text-sm font-semibold">صورة الغلاف</label>
        <p-fileUpload name="demo[]" customUpload="true" (onSelect)="onSelect($event)" (onClear)="onClear()"
          (onRemove)="onRemove($event)" [multiple]="false" chooseLabel="اختر صورة" cancelLabel="الغاء"
          accept="image/jpeg,image/png,image/gif,image/webp" [showUploadButton]="false" [showCancelButton]="false"
          chooseIcon="pi pi-image ml-2" styleClass="w-full shadow-sm">
        </p-fileUpload>
      </div>

      <!-- Editor -->
      <div style="direction: ltr !important" class="mt-4">
        <p-editor formControlName="content" placeholder="هنا تكتب الخبر..." styleClass="shadow-sm"
          [style]="{'height': '300px'}">
        </p-editor>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap gap-2 pt-4">
        <p-button type="submit" label="حفظ" severity="success" class="w-full sm:w-auto"></p-button>
        <p-button type="button" label="معاينة قبل الحفظ" severity="info" (click)="preview()"
          class="w-full sm:w-auto"></p-button>
      </div>
    </form>
  </div>

  <!-- Preview Section -->
  <div class="w-full lg:w-1/2 shadow-md rounded-xl bg-[var(--text-light)] overflow-hidden">
    <div class="p-4 h-[calc(100vh-2rem)] overflow-y-auto">
      <h1 class="text-xl sm:text-2xl font-bold text-center mb-4">المعاينة</h1>
      <hr class="mb-4">

      <!-- Preview Image -->
      <div class="relative rounded-lg overflow-hidden mb-4">
        <img *ngIf="previewText?.image_url" [src]="previewText?.image_url" alt=""
          class="w-full h-[200px] sm:h-[300px] object-cover">
      </div>

      <!-- Preview Title -->
      <h1 *ngIf="previewText?.title" class="text-xl sm:text-2xl font-bold text-center mb-4">
        العنوان: {{previewText?.title}}
      </h1>

      <!-- Preview Content -->
      <div #tag_container class="img-cont prose prose-sm max-w-none" [innerHTML]="previewText?.text">
      </div>
    </div>
  </div>
</div>